import { DataStore } from 'common/module/data/store';
import { LoaderTemplatePropsInterface } from 'common/module/loader/template-props.interface';

export class LoaderViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: LoaderTemplatePropsInterface = {
    isEnabled: false,
    isCentered: true,
  };

  /**
   * Enable loader
   */
  public enable(): void {
    this.setState({ ...this.state, isEnabled: true });
  }

  /**
   * Disable loader
   */
  public disable(): void {
    this.setState({ ...this.state, isEnabled: false });
  }

  /**
   * Toggle loader
   *
   * @param isEnabled - whether loader is enabled
   */
  public toggle(isEnabled: boolean): void {
    this.setState({ ...this.state, isEnabled });
  }

  /**
   * Center loader
   *
   * @param isCentered - whether loader should be centered
   */
  public center(isCentered: boolean): void {
    this.setState({ ...this.state, isCentered });
  }
}
